import { SystemConstants } from 'src/common/constants';

const GET_UTILITIES = 'GET_UTILITIES';
export const GET_UTILITIES_API = GET_UTILITIES + SystemConstants.API_LOADER.TRIGGER_SUFFIX;
export const GET_UTILITIES_SUCCESS = GET_UTILITIES + SystemConstants.API_LOADER.SUCCESS_SUFFIX;
export const GET_UTILITIES_ERROR = GET_UTILITIES + SystemConstants.API_LOADER.ERROR_SUFFIX;